import { ApplicationService } from './application.service';
import { BaseService } from './base.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpParams, HttpErrorResponse, HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { staticPages } from 'src/app/shared/constants/url.constants';
import { environment } from 'src/environment';


@Injectable({
    providedIn: 'root'
})

  export class StaticService {
      constructor(private http: HttpClient, private baseService: BaseService, private applicationService: ApplicationService){}

      getfooterDetails(pageId): Observable<any> {
        const staticUrl = environment.apiEndpoint + environment.version + staticPages + pageId;
        const params = new HttpParams()
          .set('region', 'int');
        return this.http.get(staticUrl, { params }).pipe(
          map(
            (response: any) => {
              if (response.status_code === 200) {
                return response.data;
              }
            }
            , (error: HttpErrorResponse) => {
              console.log(error);
            }
          )
        );
      }
  }
